import angular from 'angular';
import gridHeight from '../../core/shared-service/grid-utils';
import _ from 'lodash';

class PrincipalUserCtrl {
    /* @ngInject */
    constructor(
        $window,
        $uibModal,
        logger,
        EMAIL_REGEXP,
        KISS_USER,
        KissUserSvc,
        PrincipalSvc,
        UserBo,
        LegalEntityGroupUser,
        $translate,
        AppSvc
    ) {
        this.$window = $window;
        this.logger = logger;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
        this.KISS_USER = KISS_USER;
        this.KissUserSvc = KissUserSvc;
        this.UserBo = UserBo;
        this.$uibModal = $uibModal;
        this.PrincipalSvc = PrincipalSvc;
        this.LegalEntityGroupUser = LegalEntityGroupUser;
        this.translate = $translate;
        this.AppSvc = AppSvc;
    }

    $onInit() {
        this.includes = {
            headerTemplate: require('../principal-header-info.html'),
            errorMessages: require('../../layouts/error-messages.html'),
        };
        var ctrl = this;
        ctrl.status = this.KISS_USER.status;
        ctrl.userBo = angular.copy(ctrl.userBoData);
        ctrl.langs = ctrl.PrincipalSvc.getLangs();
        ctrl.emailConfirm = angular.copy(ctrl.userBo.user.email);
        ctrl.sso = ctrl.getSsoStatus();
        ctrl.ssoInitial = ctrl.getSsoStatus();
        ctrl.mainDivClass = 'col-md-12';
        ctrl.wkfProfiles = this.getWrkFlowProfiles();
        var defaultCellTemplate = `<div class="ui-grid-cell-contents" ng-class="row.entity.legalEntityGroup.type === 'ALL' ? 'legal-entity-group-all' : ''">{{COL_FIELD CUSTOM_FILTERS}}</div>`;
        var profileCellTemplate = `<div class="ui-grid-cell-contents" ng-class="row.entity.legalEntityGroup.type === 'ALL' ? 'legal-entity-group-all' : ''">{{grid.appScope.$ctrl.getProfileLabel(row.entity) CUSTOM_FILTERS}}</div>`;
        var deleteCellTemplate =
            '<div class="ui-grid-cell-contents text-center pointer" ng-if="!(grid.appScope.$ctrl.isSingleAdminFo && row.entity.isAdminFo())"' +
            'ng-click="grid.appScope.$ctrl.deleteAuthorization(row.entity)"><span><i class="fa fa-trash"></i></span>&nbsp;</div>';
        var searchCellTemplate =
            '<div class="ui-grid-cell-contents text-center pointer"' +
            'ng-click="grid.appScope.$ctrl.openModalSubEntity(row.entity)"><span><i class="fa fa-search"></i></span>&nbsp;</div>';
        var sortWithGroupAllFirst = function (a, b, rowA, rowB, direction) {
            var d;
            if (rowA.entity.legalEntityGroup.type === 'ALL' || a === null || a === undefined) {
                d = direction === 'asc' ? -1 : 1;
            } else if (rowB.entity.legalEntityGroup.type === 'ALL' || b === null || b === undefined) {
                d = direction === 'asc' ? 1 : -1;
            } else if (typeof a === 'number') {
                d = a - b;
            } else {
                d = a.toString().toLowerCase().localeCompare(b.toString().toLowerCase());
            }
            return d;
        };
        // Gestion de la grille
        ctrl.gridOptions = {
            columnDefs: [
                {
                    name: 'legalEntityGroup.name',
                    displayName: 'Groupe',
                    sortingAlgorithm: sortWithGroupAllFirst,
                    cellTemplate: defaultCellTemplate,
                    sort: { direction: 'asc', priority: 0 },
                },
                {
                    name: 'role',
                    displayName: 'Profil',
                    sortingAlgorithm: sortWithGroupAllFirst,
                    cellTemplate: profileCellTemplate,
                },
                {
                    name: 'search',
                    displayName: '',
                    width: '50',
                    cellTemplate: searchCellTemplate,
                    enableSorting: false,
                    visible: true,
                },
                {
                    name: 'delete',
                    displayName: '',
                    width: '50',
                    cellTemplate: deleteCellTemplate,
                    enableSorting: false,
                    visible: true,
                },
            ],
            paginationPageSize: 10,
            paginationPageSizes: [10, 50],
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
            onRegisterApi: gridApi => {
                ctrl.gridApi = gridApi;
            },
        };
        ctrl.gridOptions.data = ctrl.userBo.user && this.moveDefaultGroupToHead(ctrl.userBo.user.legalEntityGroupUsers);
    }

    getWrkFlowProfiles() {
        const profiles = new Array();

        if (this.principal.detail.threeWayMatching) {
            this.KissUserSvc.getWorkflowProfiles(this.principal.detail.id).then(treeWay => profiles.push(...treeWay));
        }

        return profiles;
    }

    getThreeWayWrkFlowProfiles() {
        return this.wkfProfiles.filter(p => p.type && p.type === 'THREE_WAY_RECONCILIATION');
    }

    getProfileLabel(legalEntityGroupUser) {
        if (legalEntityGroupUser.role === 'USER_WKF') {
            const profile = this.wkfProfiles.find(
                p => p.code === legalEntityGroupUser.wkfProfile && p.workflowScope === legalEntityGroupUser.wkfScope
            );
            return profile && profile.label ? profile.label : legalEntityGroupUser.wkfProfile;
        } else {
            return legalEntityGroupUser.getRoleLabel();
        }
    }

    /*
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight() {
        return gridHeight(this.gridApi);
    }

    /**
     * Met les groupes par défaut à la tête de la liste.
     * @param {list} legalEntityGroupUsers
     */
    moveDefaultGroupToHead(legalEntityGroupUsers) {
        if (!legalEntityGroupUsers || legalEntityGroupUsers.length <= 1) {
            return legalEntityGroupUsers;
        }
        var defaultArr = _.remove(legalEntityGroupUsers, leg => leg.legalEntityGroup.type === 'ALL');
        var sortedDefautltArr = _.sortBy(defaultArr, d => d.role);
        sortedDefautltArr.forEach(sda => legalEntityGroupUsers.unshift(sda));
        return legalEntityGroupUsers;
    }

    openGroupsModal() {
        var ctrl = this;
        this.$uibModal
            .open({
                component: 'modal-add-user-authorization',
                size: 'md',
                resolve: {
                    groups: () => ctrl.groups,
                    profiles: () => ctrl.gridOptions.data,
                    principal: () => ctrl.principal,
                    mustBeAdminFo: () => ctrl.mustBeAdminFo,
                    wkfProfiles: () => ctrl.getThreeWayWrkFlowProfiles(),
                    canHaveSalesAdmin: () => ctrl.canHaveSalesAdmin,
                },
            })
            .result.then(
                authorization => {
                    var found = _.find(ctrl.gridOptions.data, data => {
                        if (data.role === 'USER_WKF') {
                            return (
                                data.role === authorization.role &&
                                data.wkfScope === authorization.wkfScope &&
                                data.wkfProfile === authorization.wkfProfile &&
                                data.legalEntityGroup.id === authorization.legalEntityGroup.id
                            );
                        } else {
                            return (
                                data.role === authorization.role &&
                                data.legalEntityGroup.id === authorization.legalEntityGroup.id
                            );
                        }
                    });
                    if (!found) {
                        ctrl.gridOptions.data = this.moveDefaultGroupToHead(
                            ctrl.gridOptions.data.concat(authorization)
                        );
                        ctrl.gridOptions.totalItems = ctrl.gridOptions.data.length;
                        this.form.$setDirty();
                    }

                    /**
                     *  Si on ajoute un droit à un utilisateur ayant un profil "Workflow only" alors le droit "Workflow only"
                     * doit être automatiquement supprimé.
                     */
                    const wkfOnlyIndex = _.findIndex(ctrl.gridOptions.data, data => data.role === 'USER_WKF_ONLY');
                    if (wkfOnlyIndex != -1) {
                        ctrl.gridOptions.data.splice(wkfOnlyIndex, 1);
                        ctrl.gridOptions.totalItems = ctrl.gridOptions.data.length;
                        this.form.$setDirty();
                    }
                },
                () => {}
            );
    }

    deleteAuthorizationConfirmed(authorization) {
        var index = this.gridOptions.data.indexOf(authorization);
        this.gridOptions.data.splice(index, 1);
        this.gridOptions.totalItems = this.gridOptions.data.length;
        this.form.$setDirty();
    }

    openModalSubEntity(authorization) {
        const ctrl = this;
        const group = this.groups.find(grp => grp.id === authorization.legalEntityGroup.id);
        if (group)
            this.$uibModal.open({
                component: 'modal-group-list-sub-entities',
                size: 'xl',
                resolve: {
                    entities: () =>
                        ctrl.PrincipalSvc.getGroupData(this.principal.detail.id, authorization, group).then(
                            data => data
                        ),
                    cols: () => ctrl.PrincipalSvc.getGroupColumns(group),
                    legalEntityGroup: () => authorization.legalEntityGroup.id,
                    legalEntity: () => this.principal.detail.id,
                    desc: () => group.description,
                    title: () => ctrl.PrincipalSvc.getGroupTitle(group),
                    isSubEntity: () => group.nbDivisions > 0 || group.nbSubEntities > 0,
                },
                backdrop: 'static',
            });
    }

    deleteAuthorization(authorization) {
        if (this.gridOptions.data.length === 1) {
            const message = this.translate.instant('kiss_user.edit.confirm.disable', {
                login: this.userBo.user.login,
                name: this.userBo.user.lastname,
            });
            this.openConfirmDeleteAllAuthorization(authorization, message);
        } else if (
            this.gridOptions.data.filter(data => data.legalEntityGroup.principalName === this.getOwnerEntity())
                .length === 1
        ) {
            const message = this.translate.instant('kiss_user.edit.confirm.remove_from_seller', {
                login: this.userBo.user.login,
                name: this.userBo.user.lastname,
                seller: this.getOwnerEntity(),
            });
            this.openConfirmDeleteAllAuthorization(authorization, message);
        } else {
            this.deleteAuthorizationConfirmed(authorization);
        }
    }

    // Popup affichée dans le cas où on retire toutes les autorisations de l'utilisateur.
    openConfirmDeleteAllAuthorization(authorization, message) {
        this.$uibModal
            .open({
                component: 'confirmationModal',
                size: 'md',
                resolve: {
                    modalTitle: () => {
                        return { value: 'commons.confirm' };
                    },
                    modalMessage: () => {
                        return [{ key: message }];
                    },
                    modalCancelButtonText: () => {
                        return { value: 'commons.cancel' };
                    },
                    modalConfirmButtonText: () => {
                        return { value: 'commons.ok' };
                    },
                    data: () => {
                        return authorization;
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(
                authorization => this.deleteAuthorizationConfirmed(authorization),
                () => {}
            );
    }

    getOwnerEntity() {
        return this.principal.detail.corporateName;
    }

    saveUser() {
        if (this.form.$valid) {
            if (this.userBo.user.login === null) {
                const message = this.translate.instant('kiss_user.edit.confirm.create_new', {
                    firstname: this.userBo.user.firstname,
                    lastname: this.userBo.user.lastname,
                    email: this.userBo.user.email,
                });

                this.$uibModal
                    .open({
                        component: 'confirmationModal',
                        size: 'md',
                        resolve: {
                            modalTitle: () => {
                                return { value: 'kiss_user.edit.confirm.create_new_title' };
                            },
                            modalMessage: () => {
                                return [{ key: message }];
                            },
                            modalCancelButtonText: () => {
                                return { value: 'commons.cancel' };
                            },
                            modalConfirmButtonText: () => {
                                return { value: 'commons.ok' };
                            },
                        },
                        backdrop: 'static',
                        keyboard: false,
                    })
                    .result.then(
                        () => this.saveUserAction(),
                        () => {}
                    );
            } else {
                this.saveUserAction();
            }
        }
    }

    saveUserAction() {
        this.userBo.user.legalEntityGroupUsers = this.gridOptions.data;
        this.userBo.user.ownerEntityType = this.KISS_USER.userOwnerEntityType.find(type => type === 'PRINCIPAL');
        this.PrincipalSvc.saveUser(this.principal.detail.id, this.userBo.user).then(
            () => {
                this.$window.history.back();
                if (this.userBo.user.login !== null) {
                    this.logger.success('success.update', null, null, { entityName: "L'utilisateur" });
                } else {
                    this.logger.success('success.create_user');
                }
            },
            error => {
                if (error.data && error.data.code === 'DUPLICATE_CONTACT_SELLER_EMAIL') {
                    this.logger.error('error.duplicate_contact_email', error, null, null, 10000);
                } else if (error.data && error.data.code === 'UNAUTHORIZED_DOMAIN_NAME_EMAIL') {
                    this.logger.error('error.user_unauthorised_domain_name_mail', error);
                } else if (error.data && error.data.code === 'USER_GED_AUTH_WITHOUT_OTHER_DO') {
                    this.logger.error('error.functional.ged_auth_without_other_do', error);
                } else {
                    this.logger.error('error.create', error);
                }
            }
        );
    }

    /**
     * Vérifie que le formulaire est valide.
     * @returns True si valide, sinon false
     */
    isFormValid() {
        const legGroupsUser = this.gridOptions.data;
        let groupsWkf = [];

        legGroupsUser
            .filter(group => group.wkfProfile)
            .forEach(group => {
                const groupAlreayAdd = groupsWkf.filter(grp => grp.id === group.legalEntityGroup.id);
                if (groupAlreayAdd.length === 0) {
                    groupsWkf.push({ id: group.legalEntityGroup.id, name: group.legalEntityGroup.name });
                }
            });

        legGroupsUser.forEach(groupUser => {
            if (groupUser.role === 'SUPPLIER_ACCOUNTANT') {
                for (var i = 0; i < groupsWkf.length; i++) {
                    if (groupUser.legalEntityGroup.id === groupsWkf[i].id) {
                        groupsWkf.splice(i, 1);
                        break;
                    }
                }
            }
        });

        if (groupsWkf.length > 0) {
            this.logger.error('kiss_user.edit.invalid_auth', null, null, { name: groupsWkf[0].name });
        }

        return groupsWkf.length === 0 && this.form.$valid && !this.isConflictingAuth();
    }

    isConflictingAuth() {
        const legGroupsUser = this.gridOptions.data;
        return legGroupsUser.find(p => p.role === 'ACCOUNTANT') && legGroupsUser.find(p => p.role === 'ADMIN_FO');
    }

    changeStatus(status) {
        this.KissUserSvc.changeStatus(status, this.userBo.user).then(
            () => {
                // Nothing to do
            },
            error => {
                if (error.status === 400 && error.data && error.data.code === 'DUPLICATE_CONTACT_SELLER_EMAIL') {
                    this.logger.error('error.duplicate_contact_email', error, null, null, 10000);
                } else {
                    this.logger.error('error.update', error);
                }
            }
        );
    }

    canUnlock() {
        return this.userBo.user.isLocked();
    }

    cancelChanges() {
        this.userBo = angular.copy(this.userBoData);
        this.emailConfirm = this.userBo.user.login !== null ? this.userBo.user.email : null;
        this.gridOptions.data = this.userBo.user && this.userBo.user.legalEntityGroupUsers;
        this.form.$setPristine();
    }

    disableSave() {
        return this.userBo.user.login === null && this.gridOptions.data.length === 0;
    }

    isReadOnly() {
        return this.userBo.user.login && !!this.userBo.user.lastConnectionDate;
    }

    ssoReadOnly() {
        return !this.principal.detail.ssoActivated || this.ssoInitial === 'SSO_ENABLED';
    }

    getSsoStatus() {
        return this.userBo.user.domain && this.userBo.user.domain === this.principal.detail.ssoIdentifier
            ? 'SSO_ENABLED'
            : 'SSO_DISABLED';
    }

    ssoChanged() {
        this.userBo.user.domain =
            this.principal.detail.ssoActivated && this.sso === 'SSO_ENABLED'
                ? this.principal.detail.ssoIdentifier
                : null;
    }

    canCreatImpersonatedUser() {
        return (
            this.userBo.user.action !== 'REGISTRATION' &&
            (this.userBo.user.isActive() || this.userBo.user.isLocked()) &&
            !this.isImpersonatedUser() &&
            !this.userBo.user.isUserWrkFlowOnly()
        );
    }

    isImpersonatedUser() {
        return this.userBo && this.userBo.user && this.userBo.user.roles
            ? this.userBo.user.roles.some(role => role === 'IMPERSONATED')
            : false;
    }

    creatImpersonatedUser() {
        this.componentsUrls = this.AppSvc.getSyComponentsUrls();
        this.KissUserSvc.createImpersonatedUser(this.userBo.user.id).then(
            impersonatedUser => {
                this.$uibModal
                    .open({
                        component: 'impersonateUserModal',
                        size: 'md',
                        resolve: {
                            modalUser: () => impersonatedUser,
                            componentsUrls: () => this.componentsUrls,
                            modalUserFrom: () => this.userBo.user,
                        },
                        backdrop: 'static',
                        keyboard: false,
                    })
                    .result.then(
                        () => {},
                        () => {}
                    );
            },
            error => {
                this.logger.error('error.update', error);
            }
        );
    }
}

angular.module('app.principal').component('principalUserDetail', {
    templateUrl: require('./principal-user-detail.html'),
    controller: PrincipalUserCtrl,
    bindings: {
        principal: '<',
        groups: '<',
        userBoData: '<',
        isSingleAdminFo: '<',
        mustBeAdminFo: '<',
        canHaveSalesAdmin: '<',
    },
});
